import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SatisfactionForm = ({ questions, initial, onSubmit, saving, readOnly }) => {
  const [rep, setRep] = useState(initial || {});
  useEffect(() => { setRep(initial || {}); }, [initial]);
  return (
    <div className="space-y-4" data-testid="satisfaction-form">
      {questions.map(q => (
        <div key={q.id} data-testid={`sat-q-${q.id}`}>
          <p className="text-sm font-medium text-slate-800 mb-1.5">{q.libelle}</p>
          {q.type === 'note' && (
            <div className="flex gap-1.5">
              {[1, 2, 3, 4, 5].map(n => (
                <button key={n} type="button" disabled={readOnly} onClick={() => setRep({ ...rep, [q.id]: n })}
                  className={`w-9 h-9 rounded-lg border text-sm font-semibold transition-colors ${rep[q.id] === n ? 'bg-indigo-600 border-indigo-600 text-white' : 'bg-white border-slate-200 text-slate-600 hover:border-indigo-300'}`} data-testid={`sat-note-${q.id}-${n}`}>{n}</button>
              ))}
            </div>
          )}
          {q.type === 'ouinon' && (
            <div className="flex gap-2">
              {[['oui', 'Oui'], ['non', 'Non']].map(([v, l]) => (
                <button key={v} type="button" disabled={readOnly} onClick={() => setRep({ ...rep, [q.id]: v })}
                  className={`px-4 h-9 rounded-lg border text-sm font-medium ${rep[q.id] === v ? 'bg-indigo-600 border-indigo-600 text-white' : 'bg-white border-slate-200 text-slate-600'}`} data-testid={`sat-${v}-${q.id}`}>{l}</button>
              ))}
            </div>
          )}
          {q.type === 'texte' && <Textarea rows={2} disabled={readOnly} value={rep[q.id] || ''} onChange={(e) => setRep({ ...rep, [q.id]: e.target.value })} data-testid={`sat-texte-${q.id}`} />}
        </div>
      ))}
      {!readOnly && <Button onClick={() => onSubmit(rep)} disabled={saving} className="bg-indigo-600 hover:bg-indigo-700" data-testid="satisfaction-submit-btn">Enregistrer mes réponses</Button>}
    </div>
  );
};

// Saisie admin d'un questionnaire (candidat ou entreprise) pour un dossier
export const SatisfactionDialog = ({ open, onOpenChange, dossierId, cible, candidat, clientId, questions, onSaved }) => {
  const [saving, setSaving] = useState(false);
  const submit = async (reponses) => {
    setSaving(true);
    try {
      await axios.post(`${API_URL}/bilan/${dossierId}/satisfaction`, { cible, candidat_id: candidat?.candidat_id, client_id: clientId, reponses });
      toast.success('Questionnaire enregistré'); onSaved?.(); onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[85vh] overflow-y-auto" data-testid="satisfaction-dialog">
        <DialogHeader><DialogTitle>Satisfaction {cible === 'candidat' ? `— ${candidat?.nom} ${candidat?.prenom}` : 'de l\'entreprise'}</DialogTitle></DialogHeader>
        <SatisfactionForm questions={questions.filter(q => q.cible === cible)} onSubmit={submit} saving={saving} />
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Fermer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
